import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContentCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="currentColor" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M7.548 14.583q-.562 0-.951-.388a1.3 1.3 0 0 1-.389-.952V3.756q0-.563.389-.95.388-.39.951-.39h7.487q.563 0 .951.39.39.387.389.95v9.487q0 .564-.389.952t-.95.388zm0-1.083h7.487a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.177V3.756a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H7.548a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v9.487q0 .097.08.177t.176.08m-2.583 3.666q-.562 0-.951-.388a1.3 1.3 0 0 1-.389-.951V5.798a.526.526 0 0 1 .537-.542q.23 0 .388.156a.52.52 0 0 1 .158.386v10.029q0 .096.08.176.081.08.177.08h8.028a.526.526 0 0 1 .542.538.53.53 0 0 1-.155.387.52.52 0 0 1-.387.159z"
      />
    </g>
  </svg>
);
export default SvgContentCopy;
